import { Box, Flex, Heading, Image, Spinner, Text } from "@chakra-ui/core";
import React, { useEffect, useState } from "react";

import logoIcon from "../assets/logo.png";
import StoreBadges from "../components/appPromo/StoreBadges";
import {
  appDownloadQrCode,
  detectMobilePlatform,
  getStoreUrls,
} from "../services/app-download.service";

// `/app` — a QR-kód köztes címe. Telefonon a készülék típusa szerint azonnal
// továbbirányít az App Store-ba vagy a Google Playre (a link a CMS-ből jön);
// asztalon, illetve ismeretlen eszközön mindkét badge-et és a QR-t mutatja.
function AppDownloadScreen(): JSX.Element {
  const [platform] = useState(detectMobilePlatform);

  useEffect(() => {
    if (!platform) return;
    let isActive = true;
    getStoreUrls().then((urls) => {
      // `replace`: a vissza gomb ne erre az átirányító oldalra hozza vissza.
      if (isActive) window.location.replace(urls[platform]);
    });
    return () => {
      isActive = false;
    };
  }, [platform]);

  return (
    <Flex minHeight="100vh" alignItems="center" justifyContent="center" p={4}>
      <Box
        w="100%"
        maxW="420px"
        p="28px"
        borderRadius="20px"
        backgroundColor="#fff"
        color="#1c1c1c"
        textAlign="center"
      >
        <Image src={logoIcon} height="96px" width="auto" mx="auto" />
        <Heading as="h1" mt="16px" fontSize="22px" fontWeight={800}>
          Pizza Sprint app
        </Heading>
        {platform ? (
          <Flex mt="16px" alignItems="center" justifyContent="center">
            <Spinner size="sm" mr="10px" color="#da1515" />
            <Text fontSize="15px" color="#5a6069">
              Átirányítás az áruházba…
            </Text>
          </Flex>
        ) : (
          <>
            <Text mt="8px" fontSize="15px" color="#5a6069">
              Gyorsabb rendelés, kuponok és hűségpontok — mindig kéznél.
            </Text>
            <Image
              src={appDownloadQrCode()}
              width="160px"
              height="160px"
              mx="auto"
              mt="20px"
            />
            <Text mt="8px" fontSize="13px" color="#8a9098">
              Olvasd be a telefonod kamerájával
            </Text>
          </>
        )}
        <StoreBadges mt="20px" justifyContent="center" flexWrap="wrap" />
      </Box>
    </Flex>
  );
}

export default AppDownloadScreen;
